import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, NavLink } from "react-router-dom";

import EditorComponent from "../../../component/editorComponent"; // Import the centralized CKEditor component

const AddProfileArtist = () =>{

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const editorRef = useRef(); // Ref to store the CKEditor instance
    const [activeTab, setActiveTab] = useState("address"); // State to track active tab  

    const [statusID, setStatusID] = useState([]);
    const [artistTypeID, setArtistTypeID] = useState([]);
    // State for Mobile Number validation
    const [mobile, setMobileNumber] = useState("");
    const [isValidMobile, setIsValidMobile] = useState(true);

    // State for E-mail validation
    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    // State for ISD Code dropdown 
    const [isdcodes, setISDCode] = useState([]);
    const [selectedISDCode, setSelectedISDCode] = useState([]);

    const [isdSearchTerm, setISDSearchTerm] = useState('');
    const selectRef = useRef(null);

    const [featured, setFeatured] = useState(false);

    const [newdata, setNewdata] = useState({
        address:'', city: '', state: '', country: '', pin: '', gst: '', tradeName: '', aadhar: '', 
        contact: '', username: '', email: '', email_verified: 0, statusID: 0, selectedISDCode: '0', mobile: '', 
        featured_artist: 0, artistTypeID: 0, remarks: '', image: '',
        about: '', awards: '', shows: '', exhibition: ''
    });
    
    
    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
      };
    
    
    // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {

        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ISDCodeList', setISDCode);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindUserStatusList', setStatusID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindArtistTypeList', setArtistTypeID);
        
    }, []);

    // Modified useEffect for data fetching
    useEffect(() => {
        if (userInfo.user_id) {
            
            fetchData('https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAddressByUserID?User_ID=' + id, (data) => {
            
            if(data)
            {
                
                const addressData = data;
                if(addressData)
                {
                    setNewdata(prevData => ({
                        ...prevData,
                        address: addressData.address,
                        city: addressData.city,
                        state: addressData.state,
                        country: addressData.country,
                        pin: addressData.pin,
                        gst: addressData.gst,
                        tradeName: addressData.tradeName,
                        aadhar: addressData.aadhar,
                        contact: addressData.contact,
                        username: addressData.username, 
                        email: addressData.email, 
                        selectedISDCode: addressData.phonecode ? String(addressData.phonecode) : '0', // Ensure it's a string
                        mobile: addressData.mobile, 
                        userType: addressData.userType, 
                        email_verified: addressData.email_verified,
                        statusID: addressData.status, 
                        featured_artist: addressData.featured_artistID,
                        artistTypeID: addressData.artist_type,
                        remarks: addressData.remarks,
                        image: addressData.image,
                    }));

                    // Set the featured state based on the fetched data
                    if (addressData.featured_artistID === 1) {
                        setFeatured(true);
                    } else {
                        setFeatured(false);
                    }
                    
                }
               
            }
            });

            fetchData('https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAboutByUserID?User_ID=' + id, (data) => {
            
            if(data)
            {
                
            const aboutData = data;
            if(aboutData)
            {
                setNewdata(prevData => ({
                    ...prevData,
                    about: aboutData.about,
                    shows: aboutData.shows,
                    awards: aboutData.awards,
                    exhibition: aboutData.exhibition,                   
                    
                }));
               
            }
            }
            });
        
            
        }
    }, [id, fetchData]);

    // Handle keypress in the dropdown
    const handleKeyPress = (event) => {
        const value = isdSearchTerm + event.key;
        setISDSearchTerm(value);

        // Prioritize matching numeric code exactly, then matching text
        const exactMatch = isdcodes.find(code =>
            code.isdCode === value
        );

        const partialMatch = isdcodes.find(code =>
            code.isdCode.startsWith(value) ||
            code.isdCodeName.toLowerCase().includes(value.toLowerCase())
        );

        const match = exactMatch || partialMatch;

        if (match) {
            handleISDCodeChange({ target: { value: match.isdCode } });
        }
    };

    useEffect(() => {
        // Reset the search term after a short delay
        const timeoutId = setTimeout(() => setISDSearchTerm(''), 500);
        return () => clearTimeout(timeoutId);
    }, [isdSearchTerm]);


    
    const handleCheckboxChange = (event) => {
        setFeatured(event.target.checked);
    };

    const handleEmailChange = (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");
        };

    // Handler for ISD Code dropdown change
    const handleISDCodeChange = (event) => {
        const selectedCode = event.target.value;
        setSelectedISDCode(selectedCode); // This updates the separate state if needed
        setNewdata(prevData => ({
            ...prevData,
        selectedISDCode: selectedCode // Update the newdata state with the selected ISD code
        }));
    };


    const handleMobileNumberChange = (event) => {
        const inputMobileNumber = event.target.value;
        const maxLength = 10; // Set your maximum length here
    
        // Check if the pressed key is a backspace or delete
        if ((event.key === "Backspace" || event.key === "Delete")  && inputMobileNumber === ""){
            // Handle backspace or delete
            setMobileNumber("");
            setIsValidMobile(true);
          } 
          else{
        // Check if the input is numeric and does not exceed maxLength
        if (/^\d+$/.test(inputMobileNumber) && inputMobileNumber.length <= maxLength) {
            setMobileNumber(inputMobileNumber);
            setIsValidMobile(true);
          } else {
            setIsValidMobile(false);
          }
        }
        };

    // Set focus on the "Full Name" input when the component mounts
    const handleAddressChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            address: event.target.value
        }));
    };
    const handleCityChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                city: value
            }));
        }
    };
    const handleStateChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                state: value
            }));
        }
    };
    const handleCountryChange = (event) => {
        const value = event.target.value;
        // Allow only alphabetic characters and spaces
        if (/^[a-zA-Z\s]*$/.test(value) || value === '') {
            setNewdata(prevData => ({
                ...prevData,
                country: value
            }));
        }
    };
    const handlePINChange = (event) => {
        const value  = event.target.value;
        // Check if the value is numeric and has a length of up to 6 characters
        if (value === '' || (/^\d+$/.test(value) && value.length <= 6)) {
            setNewdata(prevData => ({
                ...prevData,
                pin: value
            }));
        }
    };
    const handleAadharChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            aadhar: event.target.value
        }));
    };
    const handleContactChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            contact: event.target.value
        }));
    };
    const handleGSTChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            gst: event.target.value
        }));
    };
    const handleTradeChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            tradeName: event.target.value
        }));
    };

    const handleRemarksChange = (event) => {
        setNewdata(prevData => ({
            ...prevData,
            remarks: event.target.value
        }));
    };

    const handleAboutEditorChange = (event, editor) => {
        const data = editor.getData();
        setNewdata(prevData => ({
            ...prevData,
            about: data
        }));
    };

    const handleAwardEditorChange = (event, editor) => {
        const data = editor.getData();
        setNewdata(prevData => ({
            ...prevData,
            awards: data
        }));
    };
    const handleShowEditorChange = (event, editor) => {
        const data = editor.getData();
        setNewdata(prevData => ({
            ...prevData,
            shows: data
        }));
    };
    const handleExhibitionEditorChange = (event, editor) => {
        const data = editor.getData();
        setNewdata(prevData => ({
            ...prevData,
            exhibition: data
        }));
    };
    // Capture the CKEditor instance once it's ready
    const handleEditorReady = (editor) => {
        editorRef.current = editor;
    };

    const handleAddressSubmit = async(event) => {
            event.preventDefault();

            const formData = {

            "id": id,
            "address": newdata.address,
            "city": newdata.city,
            "state": newdata.state,
            "country": newdata.country,
            "pin": newdata.pin,
            "gst": newdata.gst,
            "tradeName": newdata.tradeName,
            "aadhar": newdata.aadhar,
            "contact": newdata.contact,
            
            "createdBy": userInfo.user_id
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                const confirmed = window.confirm("Artist Address Saved Successfully !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }

            } else {
                const confirmed = window.confirm("Artist Address Not Saved !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };
    

    const handleAboutSubmit = async(event) => {
        
        event.preventDefault();

            const formData = {

            "id": id,
            "about": newdata.about,
            "awards": newdata.awards,
            "shows": newdata.shows,
            "exhibition": newdata.exhibition,            
            "createdBy": userInfo.user_id
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserAbout', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                const confirmed = window.confirm("Artist Professional Details Saved Successfully !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }

            } else {
                const confirmed = window.confirm("Artist Details Not Saved !!");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }
    };

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Add Profile' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Add Profile</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={userInfo.userType_id === 1 ? '/users' : '/viewProfileArtist'}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        {/* Tab Navigation */}
                                            <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                    <button
                                                    className={`nav-link ${activeTab === "address" ? "active" : ""}`}
                                                    onClick={() => handleTabChange("address")}
                                                    >
                                                        Address
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                    className={`nav-link ${activeTab === "about" ? "active" : ""}`}
                                                    onClick={() => handleTabChange("about")}
                                                    >
                                                        About
                                                    </button>
                                                </li>
                                            </ul>

                                        {/* Tab Content */}
                                    <div className="tab-content">
                                        <div className={`tab-pane ${activeTab === "address" ? "active" : ""}`}>
                                            {/* Address Form */}
                                        <form>
                                        <div className={`p-4 pt-2`}>                                                
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                {newdata.image && (
                                                    <img className="m-2" src={`../images/profile/${newdata.image}`} alt="" width="100px" />
                                                    )}
                                                </div>
                                                <div className="col-sm-6 form-group mb-3">
                                                        <label>Address <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <textarea type="text"
                                                            name="address"
                                                            id="address"
                                                            value={newdata.address}
                                                            maxLength={200}
                                                            rows = {3}
                                                            className="form-control"
                                                            onChange={handleAddressChange}
                                                            placeholder="Enter Address" required />                                                        

                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                <label>Artist Name <span style={{ color: "#ff0000" }}>*</span></label>
                                                <input type="text"
                                                            name="username"
                                                            id="city"
                                                            value={newdata.username}
                                                            maxLength={40}
                                                            className="form-control"
                                                            //onChange={handleCityChange}
                                                            placeholder="Enter User Name" required />    
                                                {/* <h4><label> {newdata.username}</label>  </h4><label>({newdata.userType})</label> */}
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                        <label>City <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text"
                                                            name="city"
                                                            id="city"
                                                            value={newdata.city}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleCityChange}
                                                            placeholder="Enter City" required />                                                        

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>State <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text"
                                                            name="state"
                                                            id="state"
                                                            value={newdata.state}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleStateChange}
                                                            placeholder="Enter State" required />                                                        

                                                    </div>
                                                </div>
                                            <div className="row">
                                                
                                                <div className="col-sm-2 form-group mb-1"> 
                                                                                            
                                                    <label>ISDs Code <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <select 
                                                            ref={selectRef}
                                                            value={newdata.selectedISDCode}
                                                            name="selectedISDCode"
                                                            className="form-control form-select"
                                                            onChange={handleISDCodeChange}
                                                            onKeyDown={handleKeyPress} // Add keydown event listener
                                                        >
                                                           <option value="0" >--ISD Code--</option>
                                                           {isdcodes.map((code) => (
                                                               <option key={code.isdCode} value={code.isdCode}>
                                                                   {code.isdCodeName}</option>

                                                           ))}
                                                        </select>     
                                                </div>
                                                <div className="col-sm-4 form-group mb-3">       
                                                    <label>Mobile <span style={{ color: "#ff0000" }}>*</span></label>                              
                                                    <input  type="text" 
                                                            value={newdata.mobile} 
                                                            onInput={handleMobileNumberChange} 
                                                            className={`form-control ${isValidMobile ? "" : "is-invalid"}`}
                                                            id="mobileNumber" 
                                                            placeholder="Enter your Mobile no."/>
                                                </div>
                                                    {!isValidMobile && (<div className="invalid-feedback">Mobile number exceeds maximum length.</div>)}  
                                           
                                                <div className="col-sm-3 form-group mb-3">
                                                        <label>Country <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text"
                                                            name="country"
                                                            id="country"
                                                            value={newdata.country}
                                                            maxLength={20}
                                                            className="form-control"
                                                            onChange={handleCountryChange}
                                                            placeholder="Enter Country" required />                                                        

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>PIN/ZIP Code <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text"
                                                            name="pin"
                                                            id="pin"
                                                            value={newdata.pin}
                                                            maxLength={6}
                                                            className="form-control"
                                                            onChange={handlePINChange}
                                                            placeholder="Enter PIN" required />                                                        

                                                    </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <label>Email <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text"
                                                            name="country"
                                                            id="country"
                                                            value={newdata.email}
                                                            maxLength={45}
                                                            className="form-control"
                                                            onChange={handleEmailChange}
                                                            placeholder="Enter Country" required />   
                                                
                                                </div>
                                                
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Aadhar</label>
                                                        <input type="text"
                                                            name="aadhar"
                                                            id="aadhar"
                                                            value={newdata.aadhar}
                                                            maxLength={12}
                                                            className="form-control"
                                                            onChange={handleAadharChange}
                                                            placeholder="Enter Aadhar"/>                                                      

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                    <label>Alternate Contact No</label>
                                                        <input type="text"
                                                            name="contact"
                                                            id="contact"
                                                            value={newdata.contact}
                                                            maxLength={15}
                                                            className="form-control"
                                                            onChange={handleContactChange}
                                                            placeholder="Enter Alternate Contact" />                                                   

                                                    </div>
                                                </div>
                                                <div className="row">
                                                        <div className="col-sm-3 form-group mb-3">
                                                            <label>Email Status <span style={{ color: "#ff0000" }}>*</span></label>
                                                            <select value={newdata.email_verified}  name="email_verified" className="form-control form-select">
                                                            
                                                            <option value="1">Valid</option>
                                                            <option value="0">Invalid</option>
                                                        </select>
                                                        {/* <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Featured Artist : </label>
                                                        <label>{newdata.featured_artist}</label>  */} 
                                                        </div>
                                                        <div className="col-sm-3 form-group mb-3">
                                                            <label>Artist Status <span style={{ color: "#ff0000" }}>*</span></label>
                                                            <select value={newdata.statusID} name="statusID" className="form-control form-select">
                                                                <option value={0}>--Artist Status--</option>
                                                                        {statusID.map(uStatus => (
                                                                <option key={uStatus.id} 
                                                                        value={uStatus.id}>{uStatus.statusType}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        {/* <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Status : </label>
                                                        <label>{newdata.userStatus}</label>   */}
                                                        </div>
                                                        <div className="col-sm-3 form-group mb-3">
                                                        <label>GSTIN</label>
                                                        <input type="text"
                                                            name="gst"
                                                            id="pan"
                                                            value={newdata.gst}
                                                            maxLength={15}
                                                            className="form-control"
                                                            onChange={handleGSTChange}
                                                            placeholder="Enter GSTIN" />   
                                                    </div>                                                     
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Trade Name</label>
                                                        <input type="text"
                                                            name="tradeName"
                                                            id="tradeName"
                                                            value={newdata.tradeName}
                                                            maxLength={100}
                                                            className="form-control"
                                                            onChange={handleTradeChange}
                                                            placeholder="Enter Trade Name" />   
                                                    </div>
                                                    
                                                    
                                                </div>
                                                
                                                <div className="row">
                                                    <div className="col-sm-3 form-group mt-3">
                                                        <input
                                                            type="checkbox"
                                                            id="featured"
                                                            checked={featured}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label htmlFor="terms" className="ms-2">
                                                            Featured Artist
                                                        </label>
                                                    </div>
                                                    {/* Conditionally render artistType dropdown */}
                                                    
                                                    <div className="col-sm-3 form-group mt-3">
                                                    {featured && (
                                                        <select 
                                                            value={newdata.artistTypeID} 
                                                            name="artistTypeID" 
                                                            className="form-control form-select"
                                                            onChange={(e) => setNewdata({...newdata, artistTypeID: e.target.value})}
                                                        >
                                                        <option value={0}>--Artist Type--</option>
                                                            {artistTypeID.map(aType => (
                                                                <option key={aType.id} value={aType.id}>
                                                                    {aType.artistType}
                                                        </option>
                                                        ))}
                                                        </select>
                                                    
                                                    )}
                                                    </div>
                                                    <div className="col-sm-6 form-group mt-3">
                                                       
                                                            <textarea type="text"
                                                                name="remarks"
                                                                id="remarks"
                                                                value={newdata.remarks}
                                                                maxLength={300}
                                                                rows = {3}
                                                                className="form-control"
                                                                placeholder="Enter Remarks" 
                                                                onChange={handleRemarksChange}
                                                                /> 
                                                    </div>
                                                </div>
                                                
                                                <div className="row">
                                                    <div className="col-sm-9 form-group mt-3">

                                                    </div>
                                                    <div className="col-sm-3 form-group mt-3 text-end">
                                                        {
                                                            <button type="submit"
                                                                onClick={handleAddressSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }


                                                    </div>
                                                </div>
                                        </div>
                                        </form>
                                        </div>
                                        <div className={`tab-pane ${activeTab === "about" ? "active" : ""}`}>
                                        <form>
                                            <div className={`p-4 pt-2`}>    
                                                
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>About Me*</label>

                                                        <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.about} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={handleAboutEditorChange}
                                                            placeholder="Enter Benefits / Description"

                                                        />

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Award Details*</label>

                                                        <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.awards} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={handleAwardEditorChange}
                                                            placeholder="Enter Benefits / Description"

                                                        />

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Show Details*</label>

                                                        <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.shows} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={handleShowEditorChange}
                                                            placeholder="Enter Benefits / Description"

                                                        />

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Exhibition Details*</label>

                                                        <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.exhibition} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={handleExhibitionEditorChange}
                                                            placeholder="Enter Benefits / Description"

                                                        />

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mt-3">
                                                        {
                                                            <button type="submit"
                                                                onClick={handleAboutSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </form>
                                        </div>
                                        </div>
                                        </div>
                                    </div>




                                </div>

                            </div>
                        
                    <Footer />
                </div>
                </div>
            </div>
        </>
    );
};
export default AddProfileArtist;